import { render } from "./CarouselIndicator.vue?vue&type=template&id=3e527f96"
import script from "./CarouselIndicator.vue?vue&type=script&lang=js"
export * from "./CarouselIndicator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Advanced/CarouselIndicator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e527f96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e527f96', __exports__)) {
    api.reload('3e527f96', __exports__)
  }
  
  module.hot.accept("./CarouselIndicator.vue?vue&type=template&id=3e527f96", () => {
    api.rerender('3e527f96', render)
  })

}


export default __exports__